import { render, staticRenderFns } from "./SelectedValuesInput.vue?vue&type=template&id=0f97d4a7&scoped=true"
import script from "./SelectedValuesInput.vue?vue&type=script&lang=js"
export * from "./SelectedValuesInput.vue?vue&type=script&lang=js"
import style0 from "./SelectedValuesInput.vue?vue&type=style&index=0&id=0f97d4a7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f97d4a7",
  null
  
)

export default component.exports